import { getApolloClient } from 'owa-apollo';
import {
    UpdateCalendarCharmDocument,
    UpdateCalendarCharmMutation,
    UpdateCalendarCharmMutationVariables,
} from '../graphql/__generated__/updateCalendarCharmMutation.interface';

export type UpdateCalendarCharmResult = UpdateCalendarCharmMutation['updateCalendarCharm'];

/**
 * Updates calendar charm on server
 */
export default async function updateCalendarCharmService(
    input: UpdateCalendarCharmMutationVariables
): Promise<UpdateCalendarCharmResult | null> {
    const client = await getApolloClient();

    try {
        const mutationResult = await client.mutate({
            variables: input,
            mutation: UpdateCalendarCharmDocument,
        });

        return mutationResult?.data?.updateCalendarCharm;
    } catch (e) {
        return null;
    }
}
